import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-slate-300 mt-auto" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="h-8 w-8 rounded-lg bg-white/10 flex items-center justify-center">
              <GraduationCap className="h-4 w-4 text-amber-500" />
            </div>
            <span className="font-heading font-bold text-white">Insurance License Lab</span>
          </div>
          <p className="text-sm text-slate-400">Study Smarter. Get Licensed. Modern exam prep for insurance professionals.</p>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white text-sm mb-3">Licensing</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>California — Property &amp; Casualty</li>
            <li className="opacity-60">More states coming soon</li>
            <li className="opacity-60">Life &amp; Health (soon)</li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white text-sm mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/support" className="hover:text-white">Help Center</Link></li>
            <li><Link to="/#author" className="hover:text-white">About the Author</Link></li>
            <li><Link to="/register" className="hover:text-white">Create Account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white text-sm mb-3">Legal</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Insurance License Lab. All rights reserved.</span>
          <span>Not affiliated with any state insurance department. Study aid only.</span>
        </div>
      </div>
    </footer>
  );
}
